import React, { useState } from 'react';

import newspaper from './assets/newspaper.png';
import style from './NewsletterSection.module.less';

import { Section } from '../Section';
import { NewsletterModal } from '../NewsletterModal';

interface NewsletterSectionProps {
  alternate?: boolean;
  tags?: string[]; // location on the website, will be added as a tag on Mailchimp. Will help identify sign up form
}

export const NewsletterSection: React.FC<NewsletterSectionProps> = (props) => {
  const [modalVisible, setModalVisible] = useState(false);
  return (
    <>
      <Section className={style.newsletterSection} alternate={props.alternate}>
        <h1 id="newsletter">Sign up for our newsletter</h1>
        <div className={style.row}>
          <div className={style.newspaper}>
            <img src={newspaper} alt="Newspaper" />
          </div>
          <div className={style.story}>
            <p>Leave your e-mail to be first to find out about our promotions, giveways or when we release the next game.</p>
            <button type="submit" className={style.subscribe} onClick={() => setModalVisible(true)}>Sign Up</button>
          </div>
        </div>
      </Section>
      <NewsletterModal isOpen={modalVisible} onClose={() => setModalVisible(false)} tags={props.tags} />
    </>
  );
};
